import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '../../../utils/formatNumber'
import { Employee } from '../../../types/modules/admin/employee.type'
import ToggleSwitch from '../../ui/ToggleSwitch'
import { useUpdateResource } from '../../../hooks/useUpdateResource'
import UpdateEmployeeFormWrapper from './UpdateEmployeeFormWrapper'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    employee:Employee
}

function EmployeeItem({employee}:Props) {
        const [isOpen, setIsOpen] = useState(false);

        const [isActive,setIsActive] = useState(employee.active);
        const {t}= useTranslation();

        const {updateResource} = useUpdateResource();

            async function handleChangeActive(){
                await  updateResource(`admin/${employee.id}`, {active:!isActive}, "admin",{
                    method: "PUT",
                    invalidateQueries:["employees-by-admin"],
                    confirmMessage:t("confirm_message_employee")
                });
                setIsActive(p=>!p);
            }
  return (
    <>
    <td className="p-3 min-w-[150px] text-Black font-normal text-justify">
        {formatNumber(employee.id)}
        </td>
     <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {employee.name}
        </td>

        <td className="p-3 min-w-[250px] text-Black font-normal text-justify">
        {employee.phone}
        </td>

         <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {employee.role.name}
        </td>

         <PermissionGate permissions={[PermissionsKey.UpdateAdmin]}>
            <>
            <td className="p-3 min-w-[150px] text-Black font-normal text-justify">
                <ToggleSwitch checked={isActive} size="sm" onChange={()=>{handleChangeActive()}}/>
            </td>

            <td className="p-3 min-w-[150px] text-Black font-normal text-justify">
            <button onClick={()=>setIsOpen(p=>!p)}>
                <Edit/>
            </button>
            </td>
            </>
         </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateEmployeeFormWrapper
        id={employee.id}
        defaultValues={{phone:employee.phone,roleId:employee.role.id, name:employee.name}}
        onSubmitSuccess={()=>setIsOpen(p=>false)}
        />
        </CustomModal>
    </>
  )
}

export default EmployeeItem